module.exports = __webpack_public_path__ + "media/scanner/history-20c62ded.png";